/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useRichTextToHtml } from "./use-rich-text-to-html";

/**
 * @param {object} props
 * @param {any} props.richtext
 */
export function RichTextPreview (props) {
    const { richtext, className = "" } = props || {};
    const html = useRichTextToHtml(richtext);

    return (
        <div
            className={`tiptap preview ${className}`}
            dangerouslySetInnerHTML={{
                __html: html,
            }}
        />
    );
}
